import { render, staticRenderFns } from "./DwInfo.vue?vue&type=template&id=1f5ab1da&scoped=true"
import script from "./DwInfo.vue?vue&type=script&lang=js"
export * from "./DwInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5ab1da",
  null
  
)

export default component.exports